class MapLocations {
  /**
   *
   * @param {MapServiceManager} mapServiceManager
   */
  constructor(mapServiceManager) {
    this.mapServiceManager = mapServiceManager;
    this.sections = [];
    this.locations = [];
  }
  
  initLocations() {
    this.sections = Array.from(document.querySelectorAll('.handlers-section .js-sub-section'));
  
    this.locations = Array.from(document.querySelectorAll('.js-handler-item')).map(e => new MapLocationElement(e)).sort((a, b) => {
      if (a.coordinates) {
        return -1;
      }
      if (b.coordinates) {
        return 1;
      }
    });
  }
  
  async initCoordinates(cb = null) {
    const promises = [];
    
    for (const location of this.locations) {
      if (location.coordinates) {
        cb(location);
        continue;
      }
      
      if (this.mapServiceManager.requestDelay > 0) {
        cb(await this.initCoordinatesForLocation(location));
      } else {
        promises.push(this.initCoordinatesForLocation(location).then(cb));
      }
    }
    
    return Promise.all(promises);
  }
  
  /**
   * @param {MapLocationElement} location
   * @returns {Promise<void>}
   */
  async initCoordinatesForLocation(location) {
    let address = `${location.title} ${location.street} ${location.postcode} ${location.city}`.trim();
    
    const coordinates = await this.mapServiceManager.findCoordinatesForAddress(address);
    
    if (coordinates) {
      location.coordinates = coordinates;
    }
    
    return Promise.resolve(location);
  }
  
  filterLocationsByDistance({originCoordinates, distance}) {
    if (!originCoordinates || !originCoordinates.latitude || !originCoordinates.longitude) {
      return [];
    }
    
    const filteredLocations = this.locations.filter((location) => {
      if (location.coordinates && location.coordinates.latitude && location.coordinates.longitude) {
        return this.mapServiceManager.checkDistance(originCoordinates, location.coordinates, distance);
      }
    });
    
    filteredLocations.forEach((location) => location.show());
    this.locations.filter((location) => !filteredLocations.includes(location)).forEach((location) => location.hide());
    
    this.filterSections();
    
    return filteredLocations;
  }
  
  filterSections() {
    for (const section of this.sections) {
      if (section.querySelectorAll('.js-handler-item:not([hidden])').length) {
        section.removeAttribute('hidden');
      } else {
        section.setAttribute('hidden', 'hidden');
      }
    }
  }
  
  removeFilters() {
    this.locations.forEach((location) => location.show());
    
    this.filterSections();
  }
  
  /**
   * @returns {MapLocationElement[]}
   */
  getLocations() {
    return this.locations;
  }
}

class MapLocationElement {
  constructor(element) {
    this.element = element;
    let coords = this.element.dataset.coords;
    this._coordinates = MapUtil.isValidCoordinate(coords)
      ? MapUtil.strToCoordinate(coords)
      : null;
  }
  
  get title() {
    return this.element.querySelector('.js-title')?.textContent.trim() || '';
  }
  
  get contactPerson() {
    return this.element.querySelector('.js-contact-person')?.textContent.trim() || '';
  }
  
  get street() {
    return this.element.querySelector('.js-street')?.textContent.trim() || '';
  }
  
  get postcode() {
    return this.element.querySelector('.js-postcode')?.textContent.trim() || '';
  }
  
  get city() {
    return this.element.querySelector('.js-city')?.textContent.trim() || '';
  }
  
  get phone() {
    return this.element.querySelector('.js-phone')?.textContent.trim() || '';
  }
  
  get mobile() {
    return this.element.querySelector('.js-mobile')?.textContent.trim() || '';
  }
  
  get fax() {
    return this.element.querySelector('.js-fax')?.textContent.trim() || '';
  }
  
  get email() {
    return this.element.querySelector('.js-email')?.textContent.trim() || '';
  }
  
  get website() {
    return this.element.querySelector('.js-website')?.textContent.trim() || '';
  }
  
  get shop() {
    return this.element.querySelector('.js-shop')?.textContent.trim() || '';
  }
  
  get coordinates() {
    return this._coordinates;
  }
  
  set coordinates(coordinates) {
    this._coordinates = coordinates;
  }
  
  getCoordinatesArray() {
    return [this._coordinates.latitude, this._coordinates.longitude];
  }
  
  show() {
    this.element.removeAttribute('hidden');
  }
  
  hide() {
    this.element.setAttribute('hidden', 'hidden');
  }
}

